import React from 'react';
import { Layers } from 'lucide-react';
import { useSection } from '@/app/providers';
import { SearchableSelect } from '@/core/ui/components/SearchableSelect';

/**
 * Indicador y selector de la sección activa del admin de sección (§25.7). Todo
 * el panel opera sobre esa sección: el backend la recibe como `x-section-id`.
 * Con una sola sección es solo un indicador.
 */
export const ActiveSectionSwitcher: React.FC = () => {
  const { sections, isSectionAdmin, selectedSectionId, setSelectedSectionId, loading } = useSection();

  if (!isSectionAdmin || sections.length === 0) return null;

  if (sections.length === 1) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-lg border border-theme-light bg-surface-secondary px-2.5 py-1.5 text-xs font-semibold text-theme">
        <Layers size={14} className="text-primary-600" />
        {sections[0].name}
      </span>
    );
  }

  return (
    <div className="flex items-center gap-1.5 min-w-[180px]">
      <Layers size={14} className="text-primary-600 flex-shrink-0" aria-hidden />
      <div className="flex-1">
        <SearchableSelect
          options={sections.map((section) => ({ value: section.id, label: section.name }))}
          value={selectedSectionId}
          onChange={(value) => value && setSelectedSectionId(value)}
          placeholder="Sección"
          isClearable={false}
          isSearchable={sections.length > 6}
          isDisabled={loading}
        />
      </div>
    </div>
  );
};
